/** @format */

import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import withStyles from '@material-ui/core/styles/withStyles';
import adescomStyle from '../../assets/jss/adescom/adescomStyle';
import MvnoBlockRequest from '../../interfaces/platform/MvnoBlockRequest';
import { ItemLoaders } from '../../core/loaders/ItemLoaders';
import Order from '../../interfaces/forms/Order';
import Filter from '../../interfaces/forms/Filter';
import GridItem from '../../components/Grid/GridItem';
import GridContainer from '../../components/Grid/GridContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import I18n from '../../components/Translate/I18n';
import TableBody from '@material-ui/core/TableBody';
import { TableFooter, Typography } from '@material-ui/core';
import green from '@material-ui/core/colors/green';
import amber from '@material-ui/core/colors/amber';
import deepOrange from '@material-ui/core/colors/deepOrange';
import TableHeaderContentCell from '../../components/Table/TableHeaderContentCell';
import ApiCollectionResponseInterface from '../../interfaces/api/ApiCollectionResponseInterface';
import MvnoBlockRequestItem from './components/MvnoBlockRequestItem';
import { FormGeneralHelper } from '../../helpers/FormGeneral';
import { provisionigConstants } from '../../modules/provisioning/action';
import Pager from '../../components/Adescom/PagerRange';
import moment, { Moment } from 'moment';
import { FilterHelper } from '../lib/search/FilterHelper';
import { DateHelperTs } from '../../helpers/DateHelperTs';
import Datetime from 'react-datetime';
import { PlatformResellerCollectionInterface } from '../../interfaces/collections/PlatformResellerCollectionInterface';
import { MvnoBlockListCollectionInterface } from '../../interfaces/collections/MvnoBlockListCollectionInterface';
import { brown, lime } from '@material-ui/core/colors';
import { BlockViewStateType, LegendMapInt18n } from './view/BlockViewStateType';
import CustomTextButtom from '../../components/Buttons/CustomTextButton';
import { FilterManager } from '../../modules/filter/FilterManager';
import { FilterReducerFieldName, FilterReducers } from '../../modules/filter/FilterReducers';
import FilterList from '../../components/Filter/FilterList';
import { FilterListReducerFieldName } from '../../modules/filter/FilterListReducers';
import PaperedTable from '../../components/Table/PaperedTable';
import { ListPropsInterface } from '../../modules/lib/ListPropsInterface';
import oplAppStyle from '../../assets/themes/OPL/jss/App/OplAppStyle';
import OPL_STYLE from '../../assets/themes/OPL/OplStyle';
import TableLegend from '../../components/Adescom/TableLegend';
import COLORS from '../../assets/themes/OPL/colors';

const _ = require('underscore');

interface MvnoBlockRequestResponse extends ApiCollectionResponseInterface {
    readonly 'hydra:member': Array<MvnoBlockRequest>;
}

interface MvnoBlockRequestListState {
    items: MvnoBlockRequestResponse | null;
    platformResellerList: PlatformResellerCollectionInterface | null;
    mvnoBlockList: MvnoBlockListCollectionInterface | null;
    orders: Array<Order>;
    filters: Array<Filter>;
    showClearFilterButton: boolean;
    activeRow: number;
    currentPageUri: string | null;
}

class MvnoBlockRequestList extends PureComponent<ListPropsInterface, MvnoBlockRequestListState> {
    private loaderCall: ItemLoaders;
    private filterManage: FilterManager;

    private blockStateViewType: BlockViewStateType;

    constructor(props: ListPropsInterface, context: MvnoBlockRequestListState) {
        super(props, context);
        this.state = {
            items: null,
            orders: [],
            filters: [],
            platformResellerList: null,
            mvnoBlockList: null,
            showClearFilterButton: false,
            activeRow: 0,
            currentPageUri: null,
        };
        this.loaderCall = new ItemLoaders(this.props.dispatch);
        this.blockStateViewType = new BlockViewStateType();
        this.filterManage = new FilterManager();
    }

    componentDidMount(): void {
        this.setDefaultFilter((): void => {});
        // if (Auth.isAdminMode() || Auth.isAdminExpertMode()) {
        this.loadPlatformResellers();
        // }
        this.loadMvnoBlockList();
    }

    componentDidUpdate(prevProps: Readonly<ListPropsInterface>, prevState: Readonly<MvnoBlockRequestListState>, snapshot?: any): void {
        const { dispatch, headerFilterElementHasValue, headerFilterElementName } = this.props;
        if (headerFilterElementName) {
            if (headerFilterElementHasValue) {
                this.filterManage.manageElement(headerFilterElementName, headerFilterElementHasValue);
            } else {
                this.filterManage.manageElement(headerFilterElementName, false);
            }
            this.setState({ showClearFilterButton: this.filterManage.hasManageElement() });
            dispatch({
                type: FilterReducerFieldName.HEADER_FILTER_MANAGE,
            });
        }
    }

    setActiveRow = (id: number): void => {
        const { activeRow } = this.state;
        if (activeRow === id) {
            id = 0;
        }
        this.setState({ activeRow: id });
    };

    loadMvnoBlockList = (): void => {
        this.loaderCall.getListWithCallback(
            FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/mvno_block_lists')),
            'plus_orders_common_response_block_list',
            [{ name: 'pagination', value: false }],
            [],
            (data: MvnoBlockListCollectionInterface): void => {
                this.setState({ mvnoBlockList: data });
            },
            { propagateDataToCallback: true, dispatchAfterCallback: false }
        );
    };

    loadPlatformResellers = (): void => {
        this.loaderCall.getListWithCallback(
            FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/platform_resellers')),
            'plus_orders_common_response_platform_resllers_list',
            [],
            [],
            (data: PlatformResellerCollectionInterface): void => {
                this.setState({ platformResellerList: data });
            },
            { propagateDataToCallback: true, dispatchAfterCallback: false }
        );
    };

    setDefaultFilter = (callback: () => void): void => {
        const currentPeriod = moment();
        this.setState(
            {
                showClearFilterButton: false,
                filters: [
                    { name: 'createdAt[after]', value: DateHelperTs.getMonthFirstDaySimple(currentPeriod, 'YYYY-MM-01') },
                    { name: 'createdAt[before]', value: DateHelperTs.addMonthsToDate(currentPeriod, 1).format('YYYY-MM-01') },
                ],
                orders: [{ value: 'desc', name: 'id' }],
            },
            (): void => {
                if (callback) {
                    callback();
                }
                this.firstLoad();
            }
        );
    };

    paginationCallbackFunction = (uri: string): void => {
        this.props.showMainLoader(true);
        this.loaderCall.paginationCallWithCallback(
            uri,
            provisionigConstants.BLOCK_LIST,
            (data: MvnoBlockRequestResponse): void => {
                const currentPageUri = data['@pagination']?.currentPage?.iri || null;
                this.setState({ items: data, currentPageUri: currentPageUri });
                this.props.showMainLoader(false);
            },
            { propagateDataToCallback: true, dispatchAfterCallback: false }
        );
    };

    updatePeriod = (date: string, fieldName: string): void => {
        let moment1 = moment(date);
        let filterHelper = new FilterHelper(this.state, { rangeFlag: false });
        let filter = filterHelper.updateField(fieldName + '[after]', DateHelperTs.getMonthFirstDaySimple(moment1, 'YYYY-MM-01'));
        if (filter === null) {
            return;
        }
        this.setState({ filters: filter }, (): void => {
            filterHelper = new FilterHelper(this.state, { rangeFlag: false });
            filter = filterHelper.updateField(fieldName + '[before]', DateHelperTs.addMonthsToDate(moment1, 1).format('YYYY-MM-01'));
            if (filter) {
                this.updateFilterList(filter);
            }
        });
    };

    firstLoad = (): void => {
        const { filters, orders } = this.state;
        const { dispatch } = this.props;
        this.props.showMainLoader(true);
        this.loaderCall.getListWithCallback(
            FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/mvno_block_requests')),
            provisionigConstants.BLOCK_LIST,
            filters,
            orders,
            (data: MvnoBlockRequestResponse): void => {
                const currentPageUri = data['@pagination']?.currentPage?.iri || null;
                this.setState({ items: data, currentPageUri: currentPageUri });
                this.props.showMainLoader(false);
                dispatch({
                    type: FilterListReducerFieldName.HEADER_FILTER_MANAGE,
                    showRender: true,
                });
            },
            { propagateDataToCallback: true, dispatchAfterCallback: false }
        );
    };

    updateOrderList = (orders: Array<Order>): void => this.setState({ orders: orders }, this.firstLoad);
    updateFilterList = (filters: Array<Filter>): void => this.setState({ filters: filters });

    reloadCurrentPage = (): void => {
        const { currentPageUri } = this.state;
        if (currentPageUri) {
            this.paginationCallbackFunction(currentPageUri);
        } else {
            this.firstLoad();
        }
    };

    clearFilter = (): void => {
        this.setDefaultFilter((): void => {
            const { dispatch } = this.props;
            dispatch({
                type: FilterReducerFieldName.HEADER_FILTER_MANAGE,
                clearAll: true,
            });
            dispatch({
                type: FilterListReducerFieldName.HEADER_FILTER_MANAGE,
            });
        });
    };

    render(): React.ReactNode {
        const { classes } = this.props;
        const { items, orders, filters, platformResellerList, mvnoBlockList, showClearFilterButton, activeRow } = this.state;
        const tableStickyHeader = { root: classes.tableStickyHeader };
        const tableControlStickyHeader = { root: classes.tableControlStickyHeader };
        const tableStickyCommand = { root: classes.tableStickyCommand };

        return (
            <GridContainer>
                <GridItem xs={12} md={12} lg={12}>
                    <PaperedTable
                        beforeTableContent={
                            <GridContainer>
                                <GridItem xs={12}  className={classes.beforeTableContent}>
                                    <CustomTextButtom
                                        callback={this.firstLoad}
                                        callbackParam={{}}
                                        color="primary"
                                        label="general:common.search"
                                        size="lg"
                                    />
                                    {showClearFilterButton && (
                                        <CustomTextButtom
                                            callback={this.clearFilter}
                                            callbackParam={{}}
                                            color="primary"
                                            label="general:common.clear"
                                            size="lg"
                                        />
                                    )}
                                </GridItem>
                                <GridItem xs={2} style={{marginTop: 15}} className={classes.beforeTableContent}>
                                    <I18n trans="prov:h.search_period" />
                                    <Datetime
                                        className={'top-table-date-picker'}
                                        locale="pl"
                                        {...this.props}
                                        viewMode="months"
                                        defaultValue={moment(DateHelperTs.getCurrentDateSimple('YYYY-MM-01'))}
                                        dateFormat="YYYY-MM"
                                        timeFormat={false}
                                        onChange={(moment: Moment | string): void => {
                                            if (typeof moment !== 'string') {
                                                this.updatePeriod(moment.format('YYYY-MM-01'), 'createdAt');
                                            }
                                        }}
                                        inputProps={{
                                            id: 'createdAt',
                                            placeholder: 'YYYY-MM',
                                        }}
                                    />
                                </GridItem>
                                <GridItem xs={12}>
                                    <FilterList />
                                </GridItem>
                            </GridContainer>
                        }
                    >
                        <TableHead>
                            <TableRow>
                                <TableCell classes={tableStickyCommand}>
                                    <TableHeaderContentCell textAlign="left" title="general:common.commands" onlyFilter={true} />
                                </TableCell>
                                <TableCell classes={tableStickyHeader}>
                                    <TableHeaderContentCell
                                        textAlign="left"
                                        title="prov:list.id"
                                        fieldName="id"
                                        showSort={true}
                                        onlyFilter={true}
                                        defaultDirection="desc"
                                        searchFieldType="number"
                                        filters={filters}
                                        sort={orders}
                                        updateOrderList={this.updateOrderList}
                                        updateFilterList={this.updateFilterList}
                                        searchActionCallback={this.firstLoad}
                                    />
                                </TableCell>
                                {/*<TableCell classes={tableStickyHeader}>*/}
                                {/*    <TableHeaderContentCell*/}
                                {/*        title="prov:list.operation_api_id"*/}
                                {/*        fieldName="mvnoBlockApiRequestId"*/}
                                {/*        showSort={true}*/}
                                {/*        onlyFilter={true}*/}
                                {/*        defaultDirection="desc"*/}
                                {/*        searchFieldType="number"*/}
                                {/*        filters={filters}*/}
                                {/*        sort={orders}*/}
                                {/*        updateOrderList={this.updateOrderList}*/}
                                {/*        updateFilterList={this.updateFilterList}*/}
                                {/*        searchActionCallback={this.firstLoad}*/}
                                {/*        nullable={true}*/}
                                {/*    />*/}
                                {/*</TableCell>*/}
                                {/*{(Auth.isAdminMode() || Auth.isAdminExpertMode()) && (*/}
                                <TableCell classes={tableStickyHeader}>
                                    <TableHeaderContentCell
                                        title="prov:list.partner"
                                        textAlign="center"
                                        fieldName="platformResellerId"
                                        showSort={true}
                                        onlyFilter={true}
                                        defaultDirection="desc"
                                        searchFieldType="select"
                                        selectComponent="headerPlatformReseller"
                                        filters={filters}
                                        sort={orders}
                                        updateOrderList={this.updateOrderList}
                                        updateFilterList={this.updateFilterList}
                                        searchActionCallback={this.firstLoad}
                                    />
                                </TableCell>
                                {/*)}*/}
                                <TableCell classes={tableStickyHeader}>
                                    <TableHeaderContentCell
                                        title="prov:list.block"
                                        fieldName="mvnoBlockListId"
                                        showSort={true}
                                        onlyFilter={true}
                                        defaultDirection="desc"
                                        searchFieldType="select"
                                        selectComponent="headerMvnoBlockList"
                                        filters={filters}
                                        sort={orders}
                                        updateOrderList={this.updateOrderList}
                                        updateFilterList={this.updateFilterList}
                                        platformResellerList={platformResellerList ? platformResellerList?.['hydra:member'] : []}
                                        searchActionCallback={this.firstLoad}
                                        nullable={true}
                                    />
                                </TableCell>
                                <TableCell classes={tableStickyHeader}>
                                    <TableHeaderContentCell
                                        title="prov:list.msisdn"
                                        fieldName="msisdn"
                                        showSort={true}
                                        onlyFilter={true}
                                        defaultDirection="desc"
                                        searchFieldType="number"
                                        filters={filters}
                                        sort={orders}
                                        updateOrderList={this.updateOrderList}
                                        updateFilterList={this.updateFilterList}
                                        searchActionCallback={this.firstLoad}
                                    />
                                </TableCell>
                                <TableCell classes={tableStickyHeader}>
                                    <TableHeaderContentCell
                                        title="prov:list.state"
                                        fieldName="stateId"
                                        showSort={true}
                                        onlyFilter={true}
                                        defaultDirection="desc"
                                        searchFieldType="select"
                                        selectComponent="headerCheckBoxSimpleList"
                                        elementList={this.blockStateViewType.getTypes()}
                                        filters={filters}
                                        sort={orders}
                                        updateOrderList={this.updateOrderList}
                                        updateFilterList={this.updateFilterList}
                                        searchActionCallback={this.firstLoad}
                                    />
                                </TableCell>
                                <TableCell classes={tableStickyHeader}>
                                    <TableHeaderContentCell
                                        title="prov:b.start_request_datetime"
                                        fieldName="startRequestDatetime"
                                        showSort={true}
                                        onlyFilter={true}
                                        defaultDirection="asc"
                                        searchFieldType="date"
                                        dateFromTo={true}
                                        dateFormat="RRRR-MM-DD HH:MM"
                                        filters={filters}
                                        sort={orders}
                                        breakLine={true}
                                        updateOrderList={this.updateOrderList}
                                        updateFilterList={this.updateFilterList}
                                        searchActionCallback={this.firstLoad}
                                    />
                                </TableCell>
                                <TableCell classes={tableStickyHeader}>
                                    <TableHeaderContentCell
                                        title="prov:list.block_start"
                                        fieldName="startProcessAt"
                                        showSort={true}
                                        onlyFilter={true}
                                        defaultDirection="asc"
                                        searchFieldType="date"
                                        dateFormat="RRRR-MM-DD HH:MM"
                                        dateFromTo={true}
                                        filters={filters}
                                        sort={orders}
                                        breakLine={true}
                                        updateOrderList={this.updateOrderList}
                                        updateFilterList={this.updateFilterList}
                                        searchActionCallback={this.firstLoad}
                                    />
                                </TableCell>
                                <TableCell classes={tableStickyHeader}>
                                    <TableHeaderContentCell
                                        title="prov:list.block_end"
                                        fieldName="lastRequestProcessed"
                                        showSort={true}
                                        onlyFilter={true}
                                        defaultDirection="asc"
                                        searchFieldType="date"
                                        dateFormat="RRRR-MM-DD HH:MM"
                                        dateFromTo={true}
                                        filters={filters}
                                        sort={orders}
                                        breakLine={true}
                                        updateOrderList={this.updateOrderList}
                                        updateFilterList={this.updateFilterList}
                                        searchActionCallback={this.firstLoad}
                                    />
                                </TableCell>
                                <TableCell classes={tableStickyHeader}>
                                    <TableHeaderContentCell
                                        title="prov:b.created_at"
                                        fieldName="createdAt"
                                        showSort={true}
                                        onlyFilter={true}
                                        defaultDirection="asc"
                                        searchFieldType="date"
                                        dateFromTo={true}
                                        dateFormat="RRRR-MM-DD HH:MM"
                                        filters={filters}
                                        sort={orders}
                                        breakLine={true}
                                        updateOrderList={this.updateOrderList}
                                        updateFilterList={this.updateFilterList}
                                        searchActionCallback={this.firstLoad}
                                    />
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {items &&
                                items['hydra:member'] &&
                                items['hydra:member'].map((item: MvnoBlockRequest) => {
                                    let rowActiveColor = 'white';
                                    if (activeRow === item.id) {
                                        rowActiveColor = OPL_STYLE.TABLE.ACTIVE_ROW;
                                    }
                                    return (
                                        <MvnoBlockRequestItem
                                            key={'mvnBlockReqiestItem_' + item.id}
                                            item={item}
                                            reloadCallback={this.reloadCurrentPage}
                                            platformResellerList={platformResellerList?.['hydra:member']}
                                            mvnoBlockList={mvnoBlockList?.['hydra:member']}
                                            blockViewState={this.blockStateViewType}
                                            setActiveRow={this.setActiveRow}
                                            rowActiveColor={rowActiveColor}
                                        />
                                    );
                                })}
                        </TableBody>
                        <TableFooter>
                            <TableRow>
                                <TableCell colSpan={17}>
                                    {items && items['hydra:view'] && <Pager callback={this.paginationCallbackFunction} views={items} />}
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell colSpan={17}>
                                    <TableLegend
                                        elements={[
                                            { color: '#FFF', borderColor: '#000', label: LegendMapInt18n.FINISH },
                                            {
                                                color: COLORS.ADDITIONAL.ADDITIONAL_2,
                                                borderColor: COLORS.ADDITIONAL.ADDITIONAL_2,
                                                label: LegendMapInt18n.IN_PROGRESS,
                                            },
                                            {
                                                color: COLORS.ADDITIONAL.ADDITIONAL_1,
                                                borderColor: COLORS.ADDITIONAL.ADDITIONAL_1,
                                                label: LegendMapInt18n.CALL_SUB_BLOCK,
                                            },
                                            {
                                                color: COLORS.ADDITIONAL.ADDITIONAL_5,
                                                borderColor: COLORS.ADDITIONAL.ADDITIONAL_5,
                                                label: LegendMapInt18n.CANCELED,
                                            },
                                            { color: COLORS.FUNCTION.DANGER, borderColor: COLORS.FUNCTION.DANGER, label: LegendMapInt18n.ERROR },
                                            {
                                                color: COLORS.ADDITIONAL.ADDITIONAL_4,
                                                borderColor: COLORS.ADDITIONAL.ADDITIONAL_4,
                                                label: LegendMapInt18n.RENEWAL,
                                            },
                                        ]}
                                    />
                                </TableCell>
                            </TableRow>
                        </TableFooter>
                    </PaperedTable>
                </GridItem>
            </GridContainer>
        );
    }
}

const stateToProps = (state: { filterReducer: FilterReducers }): object => {
    const { filterReducer } = state;
    if (filterReducer && filterReducer.headerFilterElementName) {
        return {
            headerFilterElementHasValue: filterReducer.headerFilterElementHasValue,
            headerFilterElementName: filterReducer.headerFilterElementName,
        };
    }
    return {};
};

export default compose<any, any>(connect(stateToProps), withStyles(oplAppStyle))(MvnoBlockRequestList);
